var map = {
	"./red1.png": "3425",
	"./red10.png": "db53",
	"./red2.png": "1b19",
	"./red3.png": "c888",
	"./red4.png": "8925",
	"./red5.png": "758b",
	"./red6.png": "c4e7",
	"./red7.png": "98b3",
	"./red8.png": "0878",
	"./red9.png": "0115"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dfe6";